export default {"src":"/_next/static/media/angle-up-solid.379704e7.svg","height":512,"width":384};